export enum InputLabel {
  BusinessTradeName = 'Business Name or DBA',
  MailingAddress = 'Mailing Address',
  MailingCity = 'Mailing City',
  MailingState = 'Mailing State',
  MailingZip = 'Mailing Zip',
  MainBusinessPhoneNumber = 'Main Business Phone Number',
  CompanyWebsite = 'Business Website',
  BusinessEmailAddress = 'Main Business Email Address',
  ConfirmBusinessEmailAddress = 'Confirm Business Email Address',
  YearsInBusiness = `Years in Business`,
  CorporateEntityName = 'Legal Business Name',
  FedTaxId = 'Federal Tax ID (EIN)',
  BusinessOwnerFirstName = 'Primary Contact Person First Name',
  BusinessOwnerLastName = 'Primary Contact Person Last Name',
  MainContactFirstName = 'Main Contact First Name',
  MainContactLastName = 'Main Contact Last Name',
  LicenseContractingServices = 'Do you hold the appropriate license(s) to perform the aforementioned contracting services?',
  ExplainSpecificLicense = 'Please explain why you do not hold this specific license',
  CorporateAddress = 'Business Address',
  CorporateCity = 'Business City',
  CorporateState = 'Business State',
  CorporateZip = 'Business Zip',
  SameAddress = 'The same address for mailing',
  PrimaryBusinessHomeImprovementCategory = 'Primary Home Improvement Category',
  OtherHomeImprovementType = 'Please Specify Home Improvement Type',
  AnnualRevenue = 'Annual Revenue',
  JobsSoldPerYear = 'Annual Jobs / Units Sold',
  SameContact = 'Business Owner same as Main Contact',
  SwimmingPool = 'Swimming Pool Type',
  BusinessEntity = 'Business Entity Structure',
  YearOfBusinessIncorporation = 'Year of Business Incorporation',
  SelectStatesWhereYouOperate = 'Select States Where You Operate',
  DoYouInstallTheProductsYouSell = 'Do you install the products you sell?',
  HowManyInstallersDoYouHave = 'How Many Installers Do You Have?',
  AssociatedManufacturer1 = 'Associated Manufacturer 1',
  AssociatedManufacturer2 = 'Associated Manufacturer 2',
  PercentOfSalesFinanced = 'Percent of Sales Financed',
  PrimaryContactPersonPhone = 'Primary Contact Person Phone',
  PrimaryContactPersonEmail = 'Primary Contact Person Email',
  PrimaryContactPersonTitle = 'Primary Contact Person Title',
  OtherHomeImprovementCategories = 'Other Home Improvement Categories',
  DoYouInstallTheProductsYouCell = 'Do you install the products you sell?',
  HowManyOwners = 'How Many Owners (include owner(s) with 25%+ ownership)',
  OwnerFirstName = 'First Name',
  OwnerLastName = 'Last Name',
  OwnerPercentageOwnedOfCompany = ' Percentage Owned of Company',
  OwnerPersonalCellPhone = ' Personal Cell Phone',
  HowDidYouHearAboutHfs = 'How Did You Hear About HFS?',
  PleaseSpecifyHomeImprovementType = 'Please Specify Home Improvement Type',
  WhoisSigningTheMasterDealerAgreement = 'Who is signing the Master Dealer Agreement?',
  SignerFirstName = "Signer's First Name",
  SignerLastName = "Signer's Last Name",
  SignerPosition = "Signer's Position",
}

export enum IntermediaryOwnerVariable {
  FirstName = 'intermediary_owner_first_name',
  LastName = 'intermediary_owner_last_name',
  PercentageOwned = 'intermediary_owner_percentage_owned',
  CellPhone = 'intermediary_owner_cell_phone',
}

export enum BusinessEntityStructure {
  Corporation = 'Corporation',
  LimitedLiabilityCompany = 'Limited Liability Company (LLC)',
  Partnership = 'Partnership',
  SoleProprietorship = 'Sole Proprietorship',
}

export enum InstallProductsYouSell {
  Yes = 'Yes',
  No = 'No',
}

export enum MainContactPosition {
  Owner = 'Owner',
  FinanceManager = 'Finance Manager',
  SalesManager = 'Sales Manager',
  AdminPerson = 'Admin Person',
  Salesperson = 'Salesperson',
  Employee = 'Employee',
}

export enum CompanyOwnersAmount {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
}

export enum HoldLicense {
  Yes = 'Yes',
  No = 'No',
}

export enum PrimaryHomeImprovementCategory {
  Additions = 'Additions',
  AduAttached = 'ADU - Attached',
  AduDetached = 'ADU - Detached',
  Basements = 'Basements',
  Bathrooms = 'Bathrooms',
  DeckingOrPatio = 'Decking / Patio',
  Electrical = 'Electrical',
  Fences = 'Fences',
  Flooring = 'Flooring',
  Hardscape = 'Hardscape',
  HomeAutomation = 'Home Automation',
  HomeEntertainment = 'Home Entertainment (mancave theater etc.)',
  HotTubs = 'Hot Tubs',
  Hvac = 'HVAC',
  Kitchens = 'Kitchens',
  Landscape = 'Landscape',
  MetalBuildings = 'Metal Buildings',
  Other = 'Other',
  OutdoorKitchens = 'Outdoor Kitchens',
  Pergolas = 'Pergolas',
  RoleBarns = 'Pole Barns',
  RoofAsphalt = 'Roof - Asphalt',
  RoofMetal = 'Roof - Metal',
  RoofShingles = 'Roof - Shingles',
  RoofTile = 'Roof - Tile',
  Saunas = 'Saunas',
  Security = 'Security',
  Solar = 'Solar',
  Siding = 'Siding',
  Spas = 'Spas',
  Sunrooms = 'Sunrooms / Three Seasons Rooms / Four Seasons Rooms',
  SwimmingPoolsInground = 'Swimming Pools - Inground',
  SwimmingPoolsAboveGround = 'Swimming Pools - Above Ground',
  SwimmingPoolsSemiInground = 'Swimming Pools - Semi-Inground',
  SwimmingPoolsRemodel = 'Swimming Pools - Remodel / Renovation',
  WaterTreatment = 'Water Treatment',
  Windows = 'Windows',
}
